import NoAccess from './NoAccess';

export default NoAccess;
